import { confirm } from '@ardoq/modal';
import { dispatchAction } from '@ardoq/rxbeach';
import {
  setPersonalSettingInBackground,
  type UpdatePersonalSettingUnion,
} from 'streams/currentUser/actions';
import { getLoadedPersonalSetting } from 'streams/currentUser/getLoadedPersonalSetting';
import type { BooleanPersonalSetting } from 'streams/currentUser/personalSettingOperations';

type MaybeShowConfirmProps = ({
  title,
  body,
  personalSettingKey,
}: {
  title: string;
  body: string;
  personalSettingKey: BooleanPersonalSetting;
}) => Promise<boolean>;

export const maybeShowConfirm: MaybeShowConfirmProps = async ({
  personalSettingKey,
  title,
  body,
}) => {
  if (await getLoadedPersonalSetting(personalSettingKey)) {
    return true;
  }

  const result = await confirm({
    title,
    text: body,
    confirmButtonTitle: 'Ok',
    cancelButtonTitle: 'Cancel',
    showRememberActionCheckbox: true,
    rememberActionCustomCheckboxText: 'Don’t show me this message again',
  });

  if (result && result.rememberAction) {
    dispatchAction(
      setPersonalSettingInBackground({
        personalSetting: personalSettingKey,
        newValue: true,
      } as UpdatePersonalSettingUnion)
    );
  }
  return Boolean(result);
};
